<template>
	<div class="register-wrapper">
		<header class="header" ref="header">
			<ArrowLeft class="fold" style="width: 2em; height: 2em;" @click="backHome"></ArrowLeft>
			<span class="title"></span>
		</header>
		<div class="mincontent">

			<div class="allContent">
				<div class="content-item">

					<el-collapse v-model="activeNames">
						<el-collapse-item name="1">
							<template #title>
								<span class="left">头像</span>
								<span class="right">
									<img v-if="imageUrl" :src="imageUrl" class="avatar">
									<img v-else :src="avatarUrl" class="avatar">
								</span>
								
							</template>
							<div class="user-con">

								<el-upload class="avatar-uploader" action="" :show-file-list="false"
									accept=".png,.PNG,.JPG,.jpg,jpeg,JPEG" :http-request="handeleBeforeUpload">
									<img v-if="imageUrl" :src="imageUrl" class="avatar" />
									<el-icon v-else class="avatar-uploader-icon">
										<Plus />
									</el-icon>
								</el-upload>
								<span
									style="font-size: 12px;color: #ccc;float: left;margin-top: 0px;margin-left: 40px;">
									支持jpg/png格式上传,文件大小不超过1M,建议上传200px*200px
								</span>
							</div>
						</el-collapse-item>

						<el-collapse-item name="2">
							<template #title>
								<span class="left">昵称</span>
								<span class="right" v-if="userTotalInfo">
									{{userTotalInfo.name}}
								</span>
								<!-- <span class="right">编辑昵称</span> -->
							</template>
							<div class="user-con" style="margin-left: 40px;">
								<div class="userInfo">
									<el-form ref="userInfoRuleForm" :model="userInfo" :rules="userInfoRules"
										class="demo-ruleForm">
										<div class="line phone loginLine">
											<el-form-item prop="name">
												<el-input maxlength="10" v-model="userInfo.name"
													placeholder="请设置10字符以内的昵称" />
											</el-form-item>
										</div>

										<div class="line login-line">
											<el-form-item>
												<el-button class="sure" @click="editName('userInfoRuleForm')">确认修改
												</el-button>
												<el-button class="cancel" @click="cancelEditName">取消</el-button>
											</el-form-item>
										</div>
									</el-form>
								</div>

							</div>
						</el-collapse-item>

						<el-collapse-item name="3">
							<template #title>
								<span class="left">手机号码</span>
								<span class="right">{{userTotalInfo.phone}}</span>
							</template>
							<div class="user-con">
								<div class="userInfo">
									<!---->
									<el-form v-if="nextFlag != '2'" :model="rulePhoneForm" :rules="phoneRules"
										ref="rulePhoneFormRef" class="demo-ruleForm" label-width="110px">
										<el-form-item label="已绑定手机">
											{{userTotalInfo.phone}}
											<!-- <span class="cancel phoneCancel" >更换手机号</span> -->
											<span class="cancel phoneCancel"
												:style="{'color':phoneCodeInfo.getCodeBtnColor}" @click="changePhone">
												{{phoneCodeInfo.getCodeText}}
											</span>
										</el-form-item>
										<!---->
										<div class="line pwd code" v-if="changePhoneFlag && nextFlag == '1' ">
											<el-form-item label="短信验证码" prop="code">
												<el-input maxlength="8" class="yzm" v-model="rulePhoneForm.code"
													placeholder="请输入短信验证码" />

											</el-form-item>
											<span class="phoneAgin" @click="phoneAgin">手机号不再使用？</span>
										</div>
										<!---->
										<div class="line login-line" v-if="changePhoneFlag && nextFlag == '1' ">
											<el-form-item>
												<el-button class="sure" @click="next">下一步</el-button>
												<el-button class="cancel" @click="cancel">取消</el-button>
											</el-form-item>
										</div>
									</el-form>
									<!---->
									<el-form v-if="nextFlag == '2'" :model="ruleNewPhoneForm" :rules="newPhoneRules"
										ref="ruleNewPhoneFormRef" class="demo-ruleForm" label-width="110px">

										<div class="line">
											<el-form-item label="新手机号" prop="phone">
												<el-input v-model="ruleNewPhoneForm.phone" placeholder="请填写您的新手机号">
												</el-input>
											</el-form-item>
										</div>
										<div class="line pwd code">
											<el-form-item label="短信验证码" prop="code">
												<el-input maxlength="8" class="yzm" v-model="ruleNewPhoneForm.code"
													placeholder="请输入短信验证码" />
												<span class="getCode"
													:style="{'color':newPhoneCodeInfo.getCodeBtnColor}"
													@click="getNewCode">
													{{newPhoneCodeInfo.getCodeText}}
												</span>
											</el-form-item>
										</div>
										<div class="line login-line">
											<el-form-item>
												<el-button class="sure" @click="editPhone">确定</el-button>
												<el-button class="cancel" @click="cancelS">取消</el-button>
											</el-form-item>
										</div>
									</el-form>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="content-item">

					<div class="item-line">
						<div class="line" @click="userAgreement">
							<div class="left">用户协议</div>
							<div class="right" >
								<i class="el-icon el-collapse-item__arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path></svg></i>
							</div>
						</div>
						<div class="line" @click="privacyPolicy">
							<div class="left">隐私政策</div>
							<div class="right" >
								<i class="el-icon el-collapse-item__arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path></svg></i>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="bottom">
				<div class="btn" @click="quitLogin">退出登录</div>
			</div>
		</div>

		<el-dialog title="温馨提示" v-model="phoneAginFlag" width="380px" align-center>
			<div class="login-content" style="height: 80px;line-height: 24px;">
				若您当前手机号不可使用，可以重新注册一个账号进行使用。
				若您有其他方面问题，也可以拨打官方客服电话，进行咨询，电话号码：025-58285029
			</div>
		</el-dialog>
		<el-dialog v-model="userAgreementFlag" width="90%" align-center>
			<div class="login-content">
				<iframe class="network_show" name="content_frame" :src="globalImgPath +'/docs/userAgreement.html'"
					frameborder=0 scrolling="no"></iframe>
			</div>
		</el-dialog>
		<el-dialog v-model="privacyPolicyFlag" width="90%" align-center>
			<div class="login-content">
				<iframe class="network_show" name="content_frame" :src="globalImgPath + '/docs/privacyPolicy.html'"
					frameborder=0 scrolling="no"></iframe>
			</div>
		</el-dialog>

		<el-dialog title="图片裁剪" v-model="picFlag" width="90%" align-center>
			<div class="login-content">
				<vue-cropper ref="cropperRef" :img="options.headImgUrl" :info="true" :autoCrop="options.autoCrop"
					:autoCropWidth="options.autoCropWidth" :autoCropHeight="options.autoCropHeight"
					:fixedBox="options.fixedBox" @realTime="realTime" />
				<div class="avatar-upload-preview" style="display: none;">
					<img :src="previews.url" :style="previews.img" />
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="picFlag = false">取 消</el-button>
					<el-button type="primary" @click="uploadPic">上传</el-button>
				</span>
			</template>
		</el-dialog>

	</div>
</template>

<script setup>
	// 手机号验证规则
	const validatePhon = (rule, value, callback) => {
		if (value === "") {
			callback(new Error("请输入手机号码"))
		} else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
			callback(new Error("请输入正确的手机号码"))
		} else {
			callback()
		}
	}
	import {
		Plus,
		ArrowLeft
	} from '@element-plus/icons-vue'
	import {
		ref,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		defineEmits
	} from "vue";

	// 需要引入的库
	import 'vue-cropper/dist/index.css'
	import {
		VueCropper
	} from 'vue-cropper'

	import {
		ElMessage
	} from 'element-plus'
	import {
		useRouter
	} from "vue-router";
	const router = useRouter()
	const emit = defineEmits(["getUserInfo"]);
	const uniHttp = getCurrentInstance().appContext.config.globalProperties;
	const globalImgPath = uniHttp.globalImgPath;
	const userInfoRuleForm = ref(null); // 注册form表单
	const rulePhoneFormRef = ref(null); // 注册form表单
	const ruleNewPhoneFormRef = ref(null); // 注册form表单
	const cropperRef = ref(null);
	const data = reactive({
		userId: '',
		activeNames: ['0'],
		imageUrl: '',
		avatarUrl: require("../../../static/images/touxiang.png"),
		fileData: null,
		file: null,
		uploadFileData: null,
		fileList: [],
		uploadFileList: [],
		userTotalInfo: {},
		userInfo: {
			name: ''
		},
		userInfoRules: {
			name: [{
				required: true,
				message: '请输入10字符以内的昵称',
				trigger: 'blur'
			}],
		},
		rulePhoneForm: {
			phone: '',
			code: ''
		},
		phoneRules: {

			phone: [{
					required: true,
					validator: validatePhon,
					trigger: 'blur',
				},
				{
					pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
					message: '请输入正确的手机号',
					trigger: 'blur'
				},
			],
			code: [{
				required: true,
				message: '请输入短信验证码',
				trigger: 'blur'
			}]
		},
		phoneCodeInfo: {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		},
		ruleNewPhoneForm: {
			phone: '',
			code: ''
		},
		newPhoneRules: {

			phone: [{
					required: true,
					validator: validatePhon,
					trigger: 'blur',
				},
				{
					pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
					message: '请输入正确的手机号',
					trigger: 'blur'
				},
			],
			code: [{
				required: true,
				message: '请输入短信验证码',
				trigger: 'blur'
			}]
		},
		newPhoneCodeInfo: {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		},
		changePhoneFlag: false, //是否更换手机号
		nextFlag: 0, //手机验证下一步
		userAgreementFlag: false,
		privacyPolicyFlag: false,
		phoneAginFlag: false,
		picFlag: false,
		//图片裁剪
		options: {
			headImgUrl: "", //裁剪图片的地址
			autoCrop: true, // 是否默认生成截图框
			autoCropWidth: 200, // 默认生成截图框宽度
			autoCropHeight: 200, // 默认生成截图框高度
			fixedBox: true, // 固定截图框大小 不允许改变
		},
		//图片预览
		previews: {},

	});


	//使用toRefs解构
	const {
		activeNames,
		userInfo,
		avatarUrl,
		imageUrl,
		userTotalInfo,
		rulePhoneForm,
		phoneCodeInfo,
		ruleNewPhoneForm,
		newPhoneCodeInfo,
		userInfoRules,
		newPhoneRules,
		phoneRules,
		nextFlag,
		changePhoneFlag,
		userAgreementFlag,
		privacyPolicyFlag,
		phoneAginFlag,
		picFlag,
		options,
		previews,

	} = toRefs(data)



	const backHome = () => {
		router.go(-1)
	}

	const handeleBeforeUpload = (file) => {
		data.picFlag = true;
		data.file = file.file;
		const reader = new FileReader();
		reader.readAsDataURL(file.file);
		reader.onload = () => {
			data.options.headImgUrl = reader.result;
		};

	}

	const realTime = (file) => {
		data.previews = file;
	}

	const uploadPic = () => {
		// FormData 对象
		data.fileData = new FormData();
		cropperRef.value.getCropBlob((file) => {
			// blob转file
			let file2 = new window.File([file], data.file.name, {
				type: file.type,
			});
			data.fileData.append("file", file2);
			editAvatar()
		})
	}

	//编辑头像
	const editAvatar = () => {
		if (data.fileData == null) {
			alert("请选选择上传头像");
			return false
		} else {
			uniHttp.$multipartPost('business/user/upload/avatar', data.fileData).then(
				res => {
					if (res.data.code == 0) {

						data.imageUrl = globalImgPath + res.data.data.avatar;
						getUserInfo();
						emit("getUserInfo"); //触发父组件获取标题列表
						ElMessage({
							showClose: true,
							message: '头像修改成功',
							type: 'success',
						})
						data.picFlag = false;
						data.activeNames = ['4']
					} else {
						alert(res.data.msg);
					}
				}
			).catch(Error => {
				console.log(Error)
			})
		}
	}

	//取消编辑姓名
	const cancelEditName = () => {
		data.activeNames = ['4']
	}

	//编辑姓名
	const editName = () => {
		userInfoRuleForm.value.validate((valid) => {
			if (valid) {
				sureEditName()
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	}

	//确认修改
	const sureEditName = () => {
		uniHttp.$applicationJson('business/user/edit', {
			id: data.userId,
			name: data.userInfo.name
		}).then(res => {
			if (res.data.code == 0) {
				getUserInfo();
				data.userInfo.name = '';
				emit("getUserInfo"); //触发父组件获取标题列表
				ElMessage({
					showClose: true,
					message: '昵称修改成功',
					type: 'success',
				})
				data.activeNames = ['4']
			} else {
				if(res.status != 203 && res.status != 205){
					ElMessage({
						showClose: true,
						message: res.data.msg,
						type: 'error',
					})
				} 
			}
		}).catch(Error => {
			console.log(Error)
		})
	}

	//更换手机号
	const changePhone = () => {
		data.changePhoneFlag = true;
		data.nextFlag = 1;
		data.rulePhoneForm.code = '';
		data.ruleNewPhoneForm = {
			phone: '',
			code: ''
		}
		getCode();
	}

	//获取验证码
	const getCode = () => {
		if (data.phoneCodeInfo.getCodeisWaiting) {
			return false
		}
		rulePhoneFormRef.value.validateField('phone', (phoneValid) => {
			if (!phoneValid) {
				return false
			} else {
				data.phoneCodeInfo.getCodeisWaiting = true;
				getDoctorSms(data.rulePhoneForm.phone, '2')
			}
		})
	}

	//定时器
	const setTimer = (registerCodeInfo) => {
		registerCodeInfo.getCodeText = "60s";
		registerCodeInfo.codeTimer = setInterval(() => {
			if (registerCodeInfo.holdTime <= 0) {
				registerCodeInfo.getCodeisWaiting = false;
				registerCodeInfo.getCodeText = "获取验证码";
				registerCodeInfo.getCodeBtnColor = '#001D7F';
				clearInterval(registerCodeInfo.codeTimer); //清除该函数
				return; //返回前面
			}
			registerCodeInfo.getCodeBtnColor = '#333';
			registerCodeInfo.getCodeText = " " + registerCodeInfo.holdTime + " s"
			registerCodeInfo.holdTime--;
		}, 1000)
	}

	//获取验证码
	const getDoctorSms = (phone, type) => {
		uniHttp.$applicationJson('business/user/sms', {
			phone: phone,
			type: type
		}).then(res => {
			if (res.data.code == 200) {
				ElMessage({
					showClose: true,
					message: '验证码已发送',
					type: 'success',
				})
				if (type == '2') {
					setTimer(data.phoneCodeInfo); //调用定时器方法
				}
				if (type == '3') {
					setTimer(data.newPhoneCodeInfo); //调用定时器方法
				}

			} else {
				if(res.status != 203 && res.status != 205){
					ElMessage({
						showClose: true,
						message: res.data.msg,
						type: 'error',
					})
				} 
			}
		}).catch(Error => {
			console.log(Error)
		})
	};

	//获取新手机号验证码
	const getNewCode = () => {
		if (data.newPhoneCodeInfo.getCodeisWaiting) {
			return false
		}
		ruleNewPhoneFormRef.value.validateField('phone', (phoneValid) => {
			if (!phoneValid) {
				return false
			} else {
				data.newPhoneCodeInfo.getCodeisWaiting = true;
				getDoctorSms(data.ruleNewPhoneForm.phone, '3')

			}
		})
	}

	//下一步
	const next = () => {
		rulePhoneFormRef.value.validate((valid) => {
			if (valid) {
				data.nextFlag = 2;
				data.phoneCodeInfo = {
					holdTime: 60,
					getCodeText: '获取验证码',
					getCodeBtnColor: '#001D7F',
					getCodeisWaiting: false,
					codeTimer: null,
				}
				data.newPhoneCodeInfo = {
					holdTime: 60,
					getCodeText: '获取验证码',
					getCodeBtnColor: '#001D7F',
					getCodeisWaiting: false,
					codeTimer: null,
				}
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	}

	//取消
	const cancel = () => {
		data.nextFlag = 0;
		clearInterval(data.phoneCodeInfo.codeTimer);
		data.rulePhoneForm.code = '';
		data.phoneCodeInfo = {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		}
		data.newPhoneCodeInfo = {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		}
		data.ruleNewPhoneForm = {
			phone: '',
			code: ''
		}
		data.activeNames = ['4']
	}

	const cancelS = () => {
		data.nextFlag = 1;
		data.rulePhoneForm.code = '';
		data.phoneCodeInfo = {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		}
		data.newPhoneCodeInfo = {
			holdTime: 60,
			getCodeText: '获取验证码',
			getCodeBtnColor: '#001D7F',
			getCodeisWaiting: false,
			codeTimer: null,
		}
		data.ruleNewPhoneForm = {
			phone: '',
			code: ''
		}
	}

	//编辑电话
	const editPhone = () => {
		ruleNewPhoneFormRef.value.validate((valid) => {
			if (valid) {
				editUserPhone()
			} else {
				console.log('error submit!!');
				return false;
			}
		});
	}

	const editUserPhone = () => {
		var arr = [{
				code: data.rulePhoneForm.code,
				phone: data.rulePhoneForm.phone,
			},
			{
				code: data.ruleNewPhoneForm.code,
				phone: data.ruleNewPhoneForm.phone,
			}
		]
		uniHttp.$applicationJson('business/user/edit/phone', arr).then(res => {
			if (res.data.code == 0) {
				getUserInfo();
				data.nextFlag = 0
				ElMessage({
					showClose: true,
					message: '手机号修改成功',
					type: 'success',
				})
				data.activeNames = ['4']
			} else {
				if(res.status != 203 && res.status != 205){
					ElMessage({
						showClose: true,
						message: res.data.msg,
						type: 'error',
					})
				} 
			}
		}).catch(Error => {
			console.log(Error)
		})
	}

	//手机不在使用
	const phoneAgin = () => {
		data.phoneAginFlag = true
	}

	//用户协议
	const userAgreement = () => {
		data.userAgreementFlag = true
	}
	//隐私政策
	const privacyPolicy = () => {
		data.privacyPolicyFlag = true
	}

	//获取个人信息
	const getUserInfo = () => {
		uniHttp.$applicationJson('business/user/info').then(res => {
			if (res.data.code == 0) {
				data.userTotalInfo = res.data.data;
				data.rulePhoneForm.phone = data.userTotalInfo.phone;
				data.userId = data.userTotalInfo.id;
				if (res.data.data.avatar) {
					data.imageUrl = globalImgPath + res.data.data.avatar;
				}
			} else {
				if(res.status != 203 && res.status != 205){
					ElMessage({
						showClose: true,
						message: res.data.msg,
						type: 'error',
					})
				} 
			}
		}).catch(Error => {
			console.log(Error)
		})
	}
	
	const quitLogin = () => {
		router.push({
			path: '/GptIndex/GptIndex'
		})
		window.localStorage.removeItem('loginFlag');
		window.localStorage.removeItem('status');
		window.localStorage.removeItem('GptMToken');
	}

	onMounted(() => {
		getUserInfo()
	})
</script>


<style lang="less" scoped>
	.register-wrapper {
		height: 100%;
		width: 100%;
		overflow-x: hidden;
		background: #fff;
		overflow-y: auto;

		.header {
			height: 4em;
			line-height: 4em;
			width: 100%;
			position: fixed;
			top: 0;
			display: none;
			.fold {
				margin-top: 1em;
				float: left;
				margin-left: 1em;
			}

			span {
				width: calc(100% - 5em);
				font-size: 16px;
				float: left;
				text-align: center;
				overflow: hidden; //超出的文本隐藏
				text-overflow: ellipsis; //溢出用省略号显示
				white-space: nowrap; // 默认不换行；
			}
		}

		.mincontent {
			position: absolute;
			top: 0.3rem;
			width: calc(100% - 1em);
			margin-left: 0.5em;
			background: #fff;
			height: calc(100% - 0.3rem);
		}
		.bottom{
			width:100%;
			margin-top: 1rem;
			.btn{
				width: 90%;
				height: 0.88rem;
				line-height: 0.88rem;
				background: #001D7F;
				margin: 0 auto;
				border-radius: 5px;
				text-align: center;
				color: #fff;
				font-size: 0.32rem;
			}
		}
		/* .mincontent {
			width: calc(100% - 80px);
			margin-left: 40px;
			background: #fff;
			height: calc(100% - 40px);
			scrollbar-width: none;
			&::-webkit-scrollbar {
				display: none;
			}
		} */

		.allContent {
			width: 96%;
			margin: 0px 2%;
			background: #fff;
			position: relative;

			.content-item {
				width: 100%;

				&:nth-child(2) {
					margin-top: 0px;
				}

				.el-collapse {
					border-top: 0px;
				}

				.item-line {
					position: relative;

					.line {
						border-bottom: 1px solid #eee;
						height: 48px;
						line-height: 48px;

						.right {
							margin-right: 2px;
							cursor: pointer;
							width:calc(100% - 4rem);
							height: 30px;
							line-height: 30px;
							padding: 2px 0px;
							border-radius: 5px;
							margin-top: 5px;
							
							.el-icon{
								font-size: 0.32rem;
							}
						}
					}
				}
			}

			.title {
				width: 100%;
				height: 40px;
				line-height: 40px;
				margin-left: 0%;
				color: #13171D;
				font-size: 0.48rem;
				margin-bottom: 20px;
			}

			.left {
				margin-left: 0.4rem;
				margin-right: 1.2rem;
				float: left;
				width: 1.7rem;
				font-size: 0.32rem;
				color: #13171D;
				font-weight: 400;
			}

			.center {
				float: left;
				width: calc(100% - 4.4rem);

				img {
					width: 30px;
					border-radius: 30px;
				}

				font-size: 0.32rem;
			}

			.right {
				float: right;
				font-size: 0.24rem;
				width: calc(100% - 3.3rem);
				text-align: right;
				font-size: 0.32rem;
				font-weight: 400;
				.el-icon{
					font-size: 0.32rem;
				}
				img{
					float: right;
					width: 0.5rem;
					border-radius: 0.5rem;
				}
			}

			.tips {
				font-size: 0.28rem;
				color: #999;
				cursor: pointer;
			}

			.user-con {
				border-top: 1px dashed #eee;
				padding-bottom: 10px;
				float: left;
				margin-left: 0.1rem;

				/deep/ .avatar-uploader {
					margin: 20px 40px 5px 40px;

					.avatar {
						width: 125px;
						height: 125px;
						display: block;
						border-radius: 125px;
					}

					.el-upload {
						border: 1px dashed var(--el-border-color);
						border-radius: 6px;
						cursor: pointer;
						position: relative;
						overflow: hidden;
						transition: var(--el-transition-duration-fast);

						&:hover {
							border-color: var(--el-color-primary);
						}
					}

					.el-icon.avatar-uploader-icon {
						font-size: 28px;
						color: #8c939d;
						width: 125px;
						height: 125px;
						text-align: center;
					}
				}

				/deep/ .userInfo {

					.el-input {
						width: 4.1rem;
						.el-input__inner{
							height: 0.8rem;
							line-height: 0.8rem;
							font-size: 0.3rem;
						}
					}
					.el-form-item{
						margin-bottom: 0.4rem;
					}
					.el-form-item__label {
						height: 34px;
						line-height: 34px;
						font-size: 0.32rem;
					}
					.el-form-item__content{
						font-size: 0.32rem;
						.el-form-item__error{
							font-size: 0.24rem;
							margin-top: 0.05rem;
							padding-bottom: 0.1rem;
						}
					}
					.sure {
						width: 100px;
						height: 0.7rem;
						line-height:0.7rem;
						background: #001D7F;
						border: 1px solid #001D7F;
						border-radius: 5px;
						margin: 0 auto;						
						text-align: center;
						color: #fff;
						font-size: 0.3rem;
					}

					.cancel {
						width: 100px;
						height: 0.7rem;
						line-height:0.7rem;
						font-size: 0.3rem;
						border-radius: 5px;
						text-align: center;
						background: #fff;
						border: 1px solid #eee;
					}

					.phoneCancel {
						margin-left: 5px;
					}

					.code {
						position: relative;

						.el-input {
							width: 4.1rem;
						}

						.getCode {
							padding: 0 10px;
							height: 0.7rem;
							line-height: 0.7rem;
							font-size: 0.3rem;
							border-radius: 5px;
							text-align: center;
							background: #fff;
							border: 1px solid #eee;
							cursor: pointer;
							margin-top: 10px;
							margin-left: 2.4rem;
						}
					}

					.phoneAgin {
						margin-left: 230px;
						margin-top: -10px;
						overflow: hidden;
						width: 100%;
						display: flex;
						margin-bottom: 10px;
						color: rgb(0, 29, 127);
						cursor: pointer;
						font-size: 0.24rem;
					}

					.login-line {
						.el-form-item__content {
							display: inline-block;
						}
					}
				}


				/deep/.demo-ruleForm {
					margin-top: 10px;
				}

				.register {
					display: inline-block;
					background: #DF707B;
					color: #fff;
					height: 30px;
					line-height: 30px;
					padding: 0 10px;
					border-radius: 3px;
					cursor: pointer;
					margin-top: 20px;
				}

				.cancel {
					background: #eee;
					color: #333;
				}

				.phoneCancel {
					display: inline-block;
					background: #eee;
					color: #333;
					height: 30px;
					line-height: 30px;
					padding: 0 0px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}

		/deep/ .el-dialog {
			border-radius: 0.3rem;
		}

		.login-content {
			height: 400px;
			overflow-y: auto;
			overflow-x: hidden;

			/deep/ .cropper-view-box {
				border-radius: 200px;
			}

			scrollbar-width: none;

			.network_show {
				width: 100%;
				height: 100%;
			}

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}
</style>
